import React from 'react';
import Modal from '../../../../components/Modal/Modal';
import {
  ButtonBack,
  ContainerProcedure,
  SubContainer
} from '../../../certificates-constancies/type1/info/components';
import Spinner from '@/presentation/components/Spinner';
import NotAvailableModal from '@/presentation/modules/procedures/components/Modals/NotAvailable';
import { BtnRequest } from '../../IssuanceUniversityCard/info/components/styled';
import { ProcedureInfoComponent } from './components/ProcedureinfoComponent';
import RequestExist from '@/presentation/modules/procedures/components/Modals/RequestExists';
import ModalScholarShip from './components/ModalScholarship';
import ProcedureHeader from '@/presentation/modules/procedures/components/ContainerProcedure/Header';

interface RetreatCourseProps {
  procedureSelectedInfo: any;
  NotAvailable: {
    showNotAvailableModal: boolean;
    setShowNotAvailableModal: (error: boolean) => void;
  };
  ProcedureExists: {
    showProcedureExists: boolean;
    setShowProcedureExists: (error: boolean) => void;
  };
  Enrollment: {
    showNotEnrollment: boolean;
    setShowNotEnrollment: (error: boolean) => void;
  };
  NotScholaShip: {
    showNotScholaShip: boolean;
    setShowNotScholaShip: (error: boolean) => void;
  };
  NotCourses: {
    showNotCourses: boolean;
    setShowNotCourses: (error: boolean) => void;
  };

  handleExistRequest: () => void;
  handlerBackButton: () => void;
  handlerRetreatPeriod: () => void;
  handlerTicket: () => void;
  url: string;
  handlerGoToExistingProcedure: () => void;
}

const RetreatCourseView: React.FC<RetreatCourseProps> = ({
  NotAvailable,
  handleExistRequest,
  handlerBackButton,
  handlerRetreatPeriod,
  procedureSelectedInfo,
  ProcedureExists,
  Enrollment,
  NotScholaShip,
  NotCourses,
  handlerTicket,
  url,
  handlerGoToExistingProcedure
}) => {
  const { setShowNotAvailableModal, showNotAvailableModal } = NotAvailable;
  const { showProcedureExists, setShowProcedureExists } = ProcedureExists;
  const { showNotEnrollment, setShowNotEnrollment } = Enrollment;
  const { showNotScholaShip, setShowNotScholaShip } = NotScholaShip;
  const { showNotCourses, setShowNotCourses } = NotCourses;
  return (
    <div data-testid="cmp-retreatCourseView">
      <ContainerProcedure>
        <SubContainer>
          <ButtonBack onClick={handlerBackButton} />
          <ProcedureHeader name="Retiro de Curso" />
        </SubContainer>
        <SubContainer>
          {!procedureSelectedInfo && <Spinner />}
          {procedureSelectedInfo && (
            <>
              <ProcedureHeader
                amount={procedureSelectedInfo?.amount}
                duration={procedureSelectedInfo?.duration}
                date={procedureSelectedInfo?.endDate}
                paddingData={12}
                paddingBottomData={12}
              />
              <ProcedureInfoComponent
                detail={procedureSelectedInfo?.detail}
                url={url}
              />
              <BtnRequest
                data-testid="cmp-btnrequest-change"
                onClick={handleExistRequest}
              >
                <p>Empezar solicitud</p>
              </BtnRequest>
            </>
          )}
        </SubContainer>
      </ContainerProcedure>
      <Modal
        show={showNotAvailableModal}
        handleClose={() => setShowNotAvailableModal(false)}
      >
        <NotAvailableModal handleClick={handlerBackButton} />
      </Modal>
      <Modal
        show={showProcedureExists}
        handleClose={() => setShowProcedureExists(false)}
      >
        <RequestExist handleClick={handlerGoToExistingProcedure} />
      </Modal>
      <Modal
        show={showNotEnrollment}
        handleClose={() => setShowNotEnrollment(false)}
      >
        <NotAvailableModal
          textInformation="Tienes que estar matriculado en el ciclo vigente"
          handleClick={handlerBackButton}
        />
      </Modal>
      <Modal
        show={showNotScholaShip}
        handleClose={() => setShowNotScholaShip(false)}
      >
        <ModalScholarShip
          hasScholarship={showNotScholaShip}
          handleClick={handlerRetreatPeriod}
        />
      </Modal>
      <Modal show={showNotCourses} handleClose={() => setShowNotCourses(false)}>
        <ModalScholarShip handleClick={handlerTicket} />
      </Modal>
    </div>
  );
};

export default RetreatCourseView;
